'use client'
import { Button } from '@/components/ui/button'
import Image from 'next/image'
import Link from 'next/link'
import React from 'react'

const HeroSection: React.FC = () => (
  <section className="flex flex-col items-center">
    <div className="relative w-full bg-white rounded-2xl sm:rounded-3xl lg:rounded-[2.5rem] overflow-hidden shadow-xl lg:shadow-2xl transition-transform duration-500 will-change-transform hover:scale-[1.005] lg:hover:scale-[1.01] flex flex-col lg:flex-row">
      {/* Left content */}
      <div className="flex-1 p-6 sm:p-8 md:p-10 lg:p-12 xl:p-16 flex flex-col justify-center order-2 lg:order-1">
        {/* Logo */}
        <div className="mb-4 lg:mb-6">
          <Link href="/">
            <Image
              src="/reach-logo.png"
              alt="ReACH Psychiatry logo"
              width={160}
              height={64}
              className="w-24 sm:w-32 lg:w-40 h-auto"
              priority
            />
          </Link>
        </div>

        {/* Headline & copy */}
        <div className="space-y-3 sm:space-y-4 lg:space-y-6">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-serif text-gray-900 leading-[1.1] tracking-tight">
            Where Compassion Meets Science
          </h1>

          <p className="text-sm sm:text-base md:text-lg lg:text-xl text-gray-600 max-w-md lg:max-w-lg leading-relaxed">
            Evidence-based mental health care, online and in-clinic
          </p>

          {/* CTA */}
          <div className="pt-3 sm:pt-5 lg:pt-8">
            <Button
              asChild
              className="w-full sm:w-auto bg-emerald-500 hover:bg-emerald-600 text-white text-xs sm:text-sm lg:text-base px-5 sm:px-8 lg:px-10 py-3 sm:py-4 lg:py-5 rounded-full shadow-lg transition-all duration-300 will-change-transform hover:scale-105 hover:-translate-y-0.5 hover:shadow-xl active:scale-95"
            >
              <Link href="/book">
                Schedule a Consultation with our care provider
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {/* Right image */}
      <div className="relative w-full lg:flex-1 aspect-[4/5] sm:aspect-[3/4] md:aspect-[4/5] lg:aspect-auto lg:min-h-[520px] overflow-hidden group order-1 lg:order-2">
        <Image
          src="/dr-meena-saari.JPG"
          alt="Professional psychiatrist portrait"
          fill
          className="object-cover object-top transition-transform duration-700 group-hover:scale-105"
          priority
          sizes="(max-width: 1024px) 100vw, 50vw"
        />
        <div className="absolute inset-0 bg-emerald-500 opacity-0 group-hover:opacity-10 transition-opacity duration-500" />
      </div>
    </div>
  </section>
)

export default HeroSection
